import * as React from 'react'

import { palette, Text } from 'main/ui'

function Required() {
  return (
    <span>
      <Text css={{ color: palette.poppy }}>*</Text>
      <Text>Indicates required</Text>
    </span>
  )
}

export default React.memo(Required)
